import cx from 'classnames'
import { useLayoutEffect, useRef } from 'react'

import { CircularProgress } from '../../shared/NarusMaterial'

import styles from './action-button.module.css'

interface ActionButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  primary?: boolean
  isLoading?: boolean
  isDisabled?: boolean
}

export function ActionButton ({ primary, isLoading, isDisabled, className, style, children, ...rest }: ActionButtonProps): JSX.Element {
  let ref = useRef<HTMLButtonElement>(null)
  let widthRef = useRef<number>()

  useLayoutEffect(() => {
    if (!isLoading) {
      widthRef.current = ref.current?.getBoundingClientRect().width
    }
  }, [ isLoading ])

  return (
    <button
      ref={ref}
      type='button'
      disabled={isDisabled}
      className={cx(className, styles.button, {
        [styles.primary ?? '']: primary
      })}
      style={{
        width: isLoading && typeof widthRef.current === 'number' ? `${widthRef.current}px` : undefined,
        ...style
      }}
      {...rest}
    >
      {isLoading && (
        <CircularProgress
          className='tiny'
          color='purple'
        />
      )}
      {!isLoading && children}
      {/* {children} */}
    </button>
  )
}

interface ActionButtonProps {
  children: React.ReactNode
}

export function ActionButtonWrapper ({ children }: ActionButtonProps): JSX.Element {
  return (
    <div className={styles.wrapper}>
      {children}
    </div>
  )
}
